<template>
  <div>
    <ul class="tab-list clearfix">
      <li
        :class="{'active':tabNum === index}"
        v-for="(item,index) in tabList"
        :key="item"
        @click="onTab(index)"
      >{{item}}</li>
    </ul>
    <div v-if="tabNum === 1">
      <ul
        class="study-list"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="20"
        v-if="studyList.length>0"
      >
        <li v-for="item in studyList" :key="item.ID">
          <router-link :to="{name: 'study-detail',params: {id:item.ID}}">
            <div class="img">
              <img
                :src="item.ListItemImage!=null?item.ListItemImage+'?x-oss-process=image/resize,m_fill,h_402,w_702':defaultImg"
                :onerror="defaultImg"
                alt
              >
            </div>
            <div class="title" style="-webkit-box-orient: vertical;">{{item.Title}}</div>
          </router-link>
        </li>
      </ul>
      <Empty v-if="isEmpty"></Empty>
      <div class="status-hint" v-show="pageHint">{{pageHint}}</div>
    </div>
    <study-news v-if="tabNum === 0"></study-news>
    <footer-logo/>
  </div>
</template>

<script>
import footerLogo from '@/components/footerLogo.vue'
import Empty from '@/views/statePage/empty.vue'
import studyNews from '@/views/study/studyNewsList.vue'
export default {
  components: {
    Empty,
    'footer-logo': footerLogo,
    'study-news': studyNews
  },
  data() {
    return {
      tabNum: 0,
      tabList: ['资讯', '视频'],
      totalPage: -1,
      pageHint: '',
      isEmpty: true,
      loading: true,
      studyList: [],
      studyData: {
        type: 1,
        pageIndex: 1,
        pageSize: 10
      },
      defaultImg: 'this.src="' + require('@/assets/images/defaultImg.png') + '"'
    }
  },
  created() {
    this.getList()
  },
  methods: {
    onTab(index) {
      this.tabNum = index
    },
    getList() {
      this.pageHint = '加载中...'
      var _this = this
      this.$fetch('/api/Course/GetCourseList', this.studyData).then(result => {
        this.isLoading = false
        _this.totalPage = result.PageCount
        if (this.studyData.pageIndex >= this.totalPage) {
          this.pageHint = '没有更多了'
          this.loading = true
        } else {
          this.pageHint = '上拉加載更多'
          this.loading = false
        }

        if (result.Items && result.Items.length > 0) {
          this.studyList = this.studyList.concat(result.Items)
          this.isEmpty = false
        } else {
          this.isEmpty = true
          this.pageHint = ''
        }
      })
    },
    loadMore() {
      if (this.studyData.pageIndex >= this.totalPage) {
        this.loading = false
      } else {
        this.loading = true
        this.pageHint = '加载中...'
        setTimeout(() => {
          this.studyData.pageIndex++
          this.getList()
        }, 1500)
      }
    }
  }
}
</script>

<style lang="less" scoped>
#success {
  background: #f7f7f7 !important;
}

.study-list {
  width: 100%;
  height: auto;
  padding: 0 24 / @rem-size 24 / @rem-size;
  background: #fff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 10 / @rem-size solid #f7f7f7;

  li {
    width: 345 / @rem-size;
    margin-top: 24 / @rem-size;

    &:active {
      .img {
        opacity: 0.8;
      }
    }

    .img {
      width: 345 / @rem-size;
      height: 240 / @rem-size;
      position: relative;

      &::after {
        display: block;
        content: '';
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 20;
      }

      &::before {
        display: block;
        content: '';
        width: 80 / @rem-size;
        height: 80 / @rem-size;
        background-image: url('../../assets/images/play-icon.png');
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        margin: auto;
        z-index: 30;
      }
    }

    .title {
      font-size: 30 / @rem-size;
      line-height: 45 / @rem-size;
      margin-top: 10 / @rem-size;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}

.tab-list {
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  padding: 0 24 / @rem-size;
  background: #fff;

  li {
    line-height: 1rem;
    float: left;
    font-size: 32 / @rem-size;
    margin-right: 20px;
    cursor: pointer;

    &.active {
      color: #005fd5;
      position: relative;

      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 2px;
        background: #005fd5;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
  }
}
</style>
